import {useQuery} from '@tanstack/react-query'

import {apiGetChart} from '../api/insights/api-get-chart'
import type {GetChartRequest} from '../api/insights/contracts'

export function useChartSeriesQuery(request: GetChartRequest) {
  const query = useQuery({
    queryKey: ['chart-series-data', request],
    queryFn: async () => {
      return apiGetChart(request)
    },
    staleTime: 60 * 1000, // data becomes stale after 1 minute
  })

  return query
}
